import "../constants-BWbGKYdG.mjs";
import "@smart/types";
import "../index-xuotMAFm.mjs";
import { g as E } from "../helpers-BfS4Sl3r.mjs";
import "../validate-feature-flags-config-O7ZXBX79.mjs";
import "../index-FzzLJwwa.mjs";
import "../index-C-My4wxZ.mjs";
import "../index-DhidOF4D.mjs";
import "@smart/configs";
function x({
  propertyLabelConfig: i,
  marketId: c,
  priceType: m
}) {
  var r, e;
  return ((r = i == null ? void 0 : i[c]) == null ? void 0 : r[m]) || ((e = i == null ? void 0 : i.DEFAULT) == null ? void 0 : e[m]);
}
const V = ({
  marketId: i,
  labels: c,
  paymentType: m,
  priceType: r
}) => {
  const {
    accordionLabelCashBuy: e,
    accordionLabelLeasing: o,
    accordionLabelLeasingSME: b,
    deliveryGroupTotalTaxFormatted: d,
    excludeVatLabel: l,
    headlineCaptionExcludesTaxLabel: v,
    headlineCaptionIncludesTaxLabel: n,
    includesVatLabel: a,
    includesVatOfLabel: U,
    leasingContractFinalizationTxt: p,
    leasingContractFinalizationTxtSME: u,
    leasingPaymentLabel: L,
    leasingPaymentLabelSME: D,
    pcpLeasingPaymentLabel: s
  } = c, S = i.toUpperCase(), t = `${U} ${d}`, T = {
    CASHBUY: {
      vatLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: a,
          commercial: a
        },
        SE: {
          private: a,
          commercial: a
        },
        DEFAULT: {
          private: a,
          commercial: l
        }
      },
      voucherVatLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: a,
          commercial: a
        },
        SE: {
          private: a,
          commercial: a
        },
        DEFAULT: {
          private: a,
          commercial: l
        }
      },
      vatOfLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: t,
          commercial: t
        },
        SE: {
          private: t,
          commercial: t
        },
        DEFAULT: {
          private: t,
          commercial: l
        }
      },
      accordionLabel: {
        DEFAULT: {
          private: e,
          commercial: e
        }
      },
      headlineCaptionTaxLabel: {
        SE: {
          private: n,
          commercial: n
        },
        DEFAULT: {
          private: n,
          commercial: v
        }
      }
    },
    LEASING: {
      vatLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: a,
          commercial: a
        },
        DEFAULT: {
          private: a,
          commercial: l
        }
      },
      paymentLabel: {
        AT: {
          private: L,
          commercial: D
        },
        DEFAULT: {
          private: L,
          commercial: L
        }
      },
      contractFinalizationStepperLabel: {
        AT: {
          private: p,
          commercial: u
        },
        DEFAULT: {
          private: p,
          commercial: p
        }
      },
      accordionLabel: {
        AT: {
          private: o,
          commercial: b
        },
        DEFAULT: {
          private: o,
          commercial: o
        }
      },
      additionalAccordionLabel: {
        DEFAULT: {
          private: e,
          commercial: e
        }
      },
      vatOfLabel: {
        AT: {
          private: a,
          commercial: a
        },
        BE: {
          private: a,
          commercial: a
        },
        FR: {
          private: t,
          commercial: t
        },
        DEFAULT: {
          private: t,
          commercial: l
        }
      },
      headlineCaptionTaxLabel: {
        DEFAULT: {
          private: n,
          commercial: v
        }
      }
    },
    // NOTE: finance is only applicable for GB (PCP leasing payment type)
    FINANCE: {
      vatLabel: {
        DEFAULT: {
          private: a,
          commercial: l
        }
      },
      paymentLabel: {
        GB: {
          private: s,
          commercial: s
        },
        DEFAULT: {
          private: L,
          commercial: L
        }
      },
      contractFinalizationStepperLabel: {
        DEFAULT: {
          private: p,
          commercial: p
        }
      },
      accordionLabel: {
        DEFAULT: {
          private: o,
          commercial: o
        }
      },
      headlineCaptionTaxLabel: {
        DEFAULT: {
          private: n,
          commercial: v
        }
      }
    }
  }, F = T == null ? void 0 : T[m];
  return E(F).reduce(
    (P, A) => ({
      ...P,
      [A]: x({
        propertyLabelConfig: F[A],
        marketId: S,
        priceType: r
      })
    }),
    {}
  );
};
function y(i, c) {
  return E(c).reduce(
    (r, e) => ({
      ...r,
      [e]: c[e][i] ?? c[e].DEFAULT
    }),
    {}
  );
}
function z({
  marketId: i,
  priceType: c,
  paymentMode: m,
  labels: r
}) {
  const e = i.toUpperCase();
  return e === "GB" && m === "finance" ? r.leasePriceLabelPCP : e === "AT" && c === "commercial" ? r.leasePriceLabelSME : r.leasePriceLabel;
}
export {
  y as getAppMarketConfig,
  V as getLabelsForMarketPriceTypePaymentType,
  z as getLeasingLabelForSpecificMarket
};
//# sourceMappingURL=index.mjs.map
